module.exports = __webpack_public_path__ + "img/home_img.3ee58903.svg";